var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-list',{attrs:{"is-loading":_vm.loading,"finished":_vm.loaded,"finished-text":_vm.$t('没有更多数据')},on:{"update:isLoading":function($event){_vm.loading=$event},"load":function () { return _vm.$emit('load'); }}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d127691","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppTmpl/AppList.vue
// module id = null
// module chunks = 